import { render } from "./ContainerReturnLocationDropdown.vue?vue&type=template&id=4d03b5ad&ts=true"
import script from "./ContainerReturnLocationDropdown.vue?vue&type=script&lang=ts"
export * from "./ContainerReturnLocationDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__